import Navigator from './navigation';

export const App = () => {
  return <Navigator />;
}


